import { useTranslation } from 'react-i18next';
import { getTermsContent } from './content';

export default function TermsOfService() {
  const { i18n } = useTranslation();
  const { title, body } = getTermsContent(i18n.language);

  return (
    <div className="min-h-[calc(100vh-var(--spacing)*45)] bg-white">
      <div className="px-6 py-10 mx-auto max-w-4xl md:px-10">
        <h1 className="text-[26px] md:text-[32px] font-bold text-[#1a1a1a] mb-4">{title}</h1>
        <div className="text-[20px] leading-[1.75] text-[#333] whitespace-pre-wrap">{body}</div>
      </div>
    </div>
  );
}
